var styles = {"inputBorder":"styles_input-border__G56Qm","errored":"styles_errored__djGzL"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
